export default __webpack_public_path__ + "static/media/process-small.080cfb1c.png";